import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import HttpParamsHelper from "../../helpers/http-params.helper";
import { LabelModel } from "../../models/api/label-model";
import { AppConfigService } from "../app-config.service";

@Injectable({
  providedIn: 'root'
})
export class ApiTranslationService {
  private readonly apiUrl: string;

  constructor(private readonly appConfigService: AppConfigService,
    private readonly httpClient: HttpClient) {
    this.apiUrl = this.appConfigService.getConfig().apiUrl;
  }


  public getForLanguage(languageCode: string, version: string): Observable<string> {
    const url = `${this.apiUrl}/api/LabelTranslation/GetByLanguage/${languageCode}`;

    const params = HttpParamsHelper.convertToHttpParams({
      v: version,
      modules: ['Foundation', 'Mutation', 'Domiciliation']
    });

    return this.httpClient.get<string>(url, { params: params });
  }

  public get(key: string): Observable<LabelModel> {
    const url = `${this.apiUrl}/api/LabelTranslation/Get`;

    const params = HttpParamsHelper.convertToHttpParams({
      key
    });

    return this.httpClient.get<LabelModel>(url, { params: params });
  }
}
